/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sanction_Mgr_Expires_AtInputs */



/**
* | output |
* | --- |
* | "Expires At" |
*
* @param {Sanction_Mgr_Expires_AtInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const sanction_mgr_expires_at = /** @type {((inputs?: Sanction_Mgr_Expires_AtInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sanction_Mgr_Expires_AtInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Expire le")
	if (locale === "es") return /** @type {LocalizedString} */ ("Expira el")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Expira em")
	if (locale === "it") return /** @type {LocalizedString} */ ("Scade il")
	return /** @type {LocalizedString} */ ("Expires At")
});